import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_post = _resolveComponent("post")!
  const _component_post_notes = _resolveComponent("post-notes")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Post",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
      (_ctx.post)
        ? (_openBlock(), _createBlock(_component_post, {
            key: 0,
            post: _ctx.post,
            trash: "",
            actions: ""
          }, null, 8, ["post"]))
        : _createCommentVNode("", true),
      (_ctx.post)
        ? (_openBlock(), _createBlock(_component_post_notes, {
            key: 1,
            "post-id": _ctx.post.id,
            class: "q-mt-md"
          }, null, 8, ["post-id"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}